import angular, { ILogService, ITimeoutService } from 'angular'
import { cloneDeep } from 'lodash'
import moment from 'moment'
import { AccesoDatos } from 'src/_candidato/comun/services/acceso-datos'
import { AppConfigService } from 'src/_candidato/comun/services/app-config.service'
import { TiposDocEstadosStore } from 'src/_candidato/data/tiposStore'
import { RestResponse } from 'src/_panel/comun/js--base--unimat--local'
import { IFilaCV, IFiltrosUltimosCV, IListadoCV, IResultadoAccionCV } from 'src/model/candidato-api'
import { BaseFeaturesComponent } from '../_base/base-features.component'
import './panel-delete-curriculums.scss'

type Filtro = {
  title: string
  desc: string
  page: string
  onactivate: (arg0: PanelDeleteCurriculumsCtrl) => void
  onend?: (arg0: PanelDeleteCurriculumsCtrl) => void
  filtros: (arg0: PanelDeleteCurriculumsCtrl) => IFiltrosUltimosCV
}

function fechaMenos(amount?: number, unit?: moment.DurationInputArg2) {
  return fechaMenosM(amount, unit).toDate()
}

function fechaMenosM(amount?: number, unit?: moment.DurationInputArg2) {
  let _m = moment()

  if (amount) {
    _m.add(-1 * amount, unit)
  }

  return _m
}

const FILTRO_DEFECTO: IFiltrosUltimosCV = {
  idcv: null,
  limit: 50,
  end: null,
  start: null,
  estado: null,
  mainq: null,
  q_value: null,
  usuarioGestor: null,
  listarPublicos: null,
}

const FILTROS: Filtro[] = [
  {
    title: 'Filter by date',
    desc: 'Last month',
    page: 'Curriculums Between Dates',
    onactivate(ctrl) {
      ctrl.filtrarFechas()
    },
    onend(ctrl) {
      ctrl.filtrarFechas(false)
    },
    filtros(ctrl) {
      return {
        limit: -1,
        end: (ctrl.filtroFechas.fin && new Date(ctrl.filtroFechas.fin)) || null,
        start: (ctrl.filtroFechas.inicio && new Date(ctrl.filtroFechas.inicio)) || null,
        estado: null,
        mainq: null,
        q_value: null,
      } as IFiltrosUltimosCV
    },
  },
]

class PanelDeleteCurriculumsCtrl extends BaseFeaturesComponent {
  filtros!: boolean

  $loading = false
  listado: IListadoCV
  listadolist: IFilaCV[]
  filtrosList: typeof FILTROS
  filtroActivo: Filtro | null = null

  panelcv = {
    $visible: false,
    cv: null as IFilaCV,
  }

  filtroFechas = {
    visible: false,
    inicio: null as Date,
    fin: fechaMenosM(1, 'year').format('ll'),
  }

  total = {
    count: 0,
    valid: false,
  }

  _estados = {
    REVISED: 'zzzzzz',
  }

  datosTipos: TiposDocEstadosStore

  delete = {
    active: false,
    confirm: false,
    processing: false,
    cvmap: {} as { [idcv: number]: boolean },
    msgs: [] as string[],
  }

  constructor(
    private $element: JQLite,
    private $log: ILogService,
    private $timeout: ITimeoutService,
    private AccesoDatos: AccesoDatos,
    appConfigService: AppConfigService
  ) {
    super(appConfigService)
  }

  $onInit(): void {
    this.$log.info('[PanelDeleteCurriculumsCtrl] onInit')

    this.filtrosList = cloneDeep(FILTROS)
    this.activaFiltro(this.filtrosList[0])

    this.AccesoDatos.Datos_Client.tiposParaDocuemntos().then(
      (tiposResponse) => (this.datosTipos = new TiposDocEstadosStore(tiposResponse))
    )
  }

  private _busqueda() {
    this._resetDelete()

    // al inicio, obtener los ítems de menú disponibles, no solo los visibles
    let filtros: RestResponse<IListadoCV>
    if (this.filtros) {
      let _filtrosBusqueda = (this.filtroActivo && this.filtroActivo.filtros(this)) || cloneDeep(FILTRO_DEFECTO)

      filtros = this._busquedaClient().listCV(_filtrosBusqueda)
    } else filtros = this._busquedaClient().lastCV()

    filtros.then((listadoResponse) => {
      this.$log.info('listado', listadoResponse)
      this.listado = null
      this.listadolist = null

      this.$timeout(() => {
        this.listado = listadoResponse
        this.listadolist = listadoResponse.list
      })
    })
  }

  private _busquedaClient() {
    if (this.esAdmin()) {
      return this.AccesoDatos.GestionCurr_CLIENT
    } else {
      return this.AccesoDatos.GestionSolicitudes_CLIENT
    }
  }

  accesscv(idx: number) {
    this.$log.debug('access', this.listado.list[idx])
    this.panelcv.cv = this.listado.list[idx]
    this.panelcv.$visible = true
  }

  filtrarFechas(forzar?: boolean) {
    this.filtroFechas.visible = forzar ?? !this.filtroFechas.visible
  }

  aplicaFiltros() {
    this._busqueda()
  }

  activaFiltro(f: Filtro) {
    this.filtroActivo?.onend && this.filtroActivo.onend(this)

    this.filtroActivo = f

    f.onactivate(this)
  }

  estadoDesc(f: IFilaCV) {
    this.$log.info(' estadoDesc!!!!!!', f)

    return f.cv.estado + ' xxx'
  }

  updateAccionCV(cvdata: IResultadoAccionCV) {
    this.$log.info(' update!!!!!!', cvdata)

    let _actualcv = this.panelcv.cv

    _actualcv.cv.estado = cvdata.actionitem.state
  }

  get estados() {
    this.$log.info('====> estados!!!!')

    return this._estados
  }

  deletecv() {
    this.delete.processing = false
    this.delete.active = !this.delete.active

    if (this.delete.active) {
      this.delete.confirm = true
      this.delete.msgs = []
    }

    this.$log.info('selected', this.delete.cvmap)
  }

  private _resetDelete() {
    this.delete = {
      active: false,
      confirm: false,
      processing: false,
      cvmap: {},
      msgs: [],
    }
  }

  reallyDelete() {
    this.delete.confirm = false
    this.delete.processing = true

    this.delete.msgs.push('-- Process start --')
    this.process(0)
  }

  private async process(idx: number) {
    if (!this.delete.processing) return

    if (idx >= this.listado.list.length) {
      this.delete.msgs.push('-- Process finished --')
      return
    }

    let _cv = this.listado.list[idx]
    let _id = _cv.cv.idcv

    let _result = null
    if (this.delete.cvmap[_id]) {
      _result = await this._deletecv(_cv)

      this.delete.msgs.push(`Delete C.V. Id ${_id} ( ${moment(_cv.cv.fcalta).format('DD MMM YY HH:mm')} ):  Success`)
    }

    // para actualizar los mensajes
    this.$timeout(() => {
      let result = this.process(idx + 1)
    }, 5)

    return _result
  }

  private async _deletecv(_cv: IFilaCV) {
    if (this.esAdmin()) {
      return this.AccesoDatos.HistoricCurr_CLIENT.borrarCv(_cv.cv.form_id, _cv.cv.idcv)
    } else {
      return this.AccesoDatos.HistoricSolicitudes_CLIENT.borrarCv(_cv.cv.form_id, _cv.cv.idcv)
    }
  }

  selectAll() {
    this.listado.list.forEach((cv) => (this.delete.cvmap[cv.cv.idcv] = true))
  }
}

angular.module('candidato').component('panelDeleteCurriculums', {
  bindings: {
    filtros: '<',
  },
  controller: PanelDeleteCurriculumsCtrl,
  template: require('./panel-delete-curriculums.component.html'),
  // templateUrl: "panel-delete-curriculums.component.html",
})
